module.exports = __webpack_public_path__ + "static/media/interiorimg.a1f6d4a1.png";